module.exports = __webpack_public_path__ + "static/gay-parade-banner.9d23b66a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gay-parade-banner.jpg
// module id = 473
// module chunks = 86186464225756